import React from "react";
import { Link } from "react-router-dom";

const submenuItems = [
  {
    title: "My Profile",
    path: "/profile",
  },
];

const PlayerHeaderSubmenu = ({
  profileData,
  getProfileDisplay,
  handleLogout,
}) => {
  return (
    <div className="absolute right-0 mt-2 w-[320px] bg-white border rounded-2xl shadow-lg py-6 z-50">
      <div className="w-full flex flex-col justify-center items-center gap-1">
        {profileData?.player_details?.player_image ? (
          <img
            src={profileData?.player_details?.player_image}
            alt={profileData?.player_details?.name}
            className="h-12 w-12 rounded-full object-cover"
          />
        ) : (
          <div className="h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center text-lg">
            {getProfileDisplay(profileData).initials}
          </div>
        )}

        <span className="text-[#0A0F2D] text-xl font-medium mt-2">
          {profileData?.first_name || profileData?.name || "N/A"}
        </span>

        <span className="text-xs text-[#646B7E] pb-6 border-b border-[#D6DBEA] w-[75%] text-center">
          {profileData?.email || "N/A"}
        </span>

        <div className="w-[70%] mx-auto flex flex-col justify-center gap-3 mt-8 items-center">
          {submenuItems.map((item) => (
            <div className="flex w-full items-center gap-4" key={item.path}>
              <div>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect width="32" height="32" rx="8" fill="#F7F7F7" />
                  <mask
                    id="mask0_2180_4050"
                    maskUnits="userSpaceOnUse"
                    x="8"
                    y="8"
                    width="24"
                    height="24"
                  >
                    <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2180_4050)">
                    <path
                      d="M15.9996 15.9996C15.1196 15.9996 14.3663 15.6863 13.7396 15.0596C13.1129 14.4329 12.7996 13.6796 12.7996 12.7996C12.7996 11.9196 13.1129 11.1663 13.7396 10.5396C14.3663 9.91294 15.1196 9.59961 15.9996 9.59961C16.8796 9.59961 17.6329 9.91294 18.2596 10.5396C18.8863 11.1663 19.1996 11.9196 19.1996 12.7996C19.1996 13.6796 18.8863 14.4329 18.2596 15.0596C17.6329 15.6863 16.8796 15.9996 15.9996 15.9996ZM9.59961 20.7996V20.1596C9.59961 19.7063 9.71628 19.2896 9.94961 18.9096C10.1829 18.5296 10.4929 18.2396 10.8796 18.0396C11.7063 17.6263 12.5463 17.3163 13.3996 17.1096C14.2529 16.9029 15.1196 16.7996 15.9996 16.7996C16.8796 16.7996 17.7463 16.9029 18.5996 17.1096C19.4529 17.3163 20.2929 17.6263 21.1196 18.0396C21.5063 18.2396 21.8163 18.5296 22.0496 18.9096C22.2829 19.2896 22.3996 19.7063 22.3996 20.1596V20.7996C22.3996 21.2396 22.2429 21.6163 21.9296 21.9296C21.6163 22.2429 21.2396 22.3996 20.7996 22.3996H11.1996C10.7596 22.3996 10.3829 22.2429 10.0696 21.9296C9.75628 21.6163 9.59961 21.2396 9.59961 20.7996ZM11.1996 20.7996H20.7996V20.1596C20.7996 20.0129 20.7629 19.8796 20.6896 19.7596C20.6163 19.6396 20.5196 19.5463 20.3996 19.4796C19.6796 19.1196 18.9529 18.8496 18.2196 18.6696C17.4863 18.4896 16.7463 18.3996 15.9996 18.3996C15.2529 18.3996 14.5129 18.4896 13.7796 18.6696C13.0463 18.8496 12.3196 19.1196 11.5996 19.4796C11.4796 19.5463 11.3829 19.6396 11.3096 19.7596C11.2363 19.8796 11.1996 20.0129 11.1996 20.1596V20.7996ZM15.9996 14.3996C16.4396 14.3996 16.8163 14.2429 17.1296 13.9296C17.4429 13.6163 17.5996 13.2396 17.5996 12.7996C17.5996 12.3596 17.4429 11.9829 17.1296 11.6696C16.8163 11.3563 16.4396 11.1996 15.9996 11.1996C15.5596 11.1996 15.1829 11.3563 14.8696 11.6696C14.5563 11.9829 14.3996 12.3596 14.3996 12.7996C14.3996 13.2396 14.5563 13.6163 14.8696 13.9296C15.1829 14.2429 15.5596 14.3996 15.9996 14.3996Z"
                      fill="#43526E"
                    />
                  </g>
                </svg>
              </div>
              <Link
                to={item.path}
                className="text-[#0A0F2D] text-base font-medium"
              >
                {item.title}
              </Link>
            </div>
          ))}

          {/* Security — manage trusted devices (skip-OTP for 14 days). */}
          <div className="flex w-full items-center gap-4">
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="8" fill="#F7F7F7" />
                <path
                  d="M16 9.6L10.4 12v4.8c0 3.55 2.39 6.87 5.6 7.6 3.21-.73 5.6-4.05 5.6-7.6V12L16 9.6zm0 6.39h4.4c-.33 2.63-2.09 4.97-4.4 5.69V16h-4.4V12.75L16 10.96v5.03z"
                  fill="#43526E"
                />
              </svg>
            </div>
            <Link
              to="/settings/security"
              className="text-[#0A0F2D] text-base font-medium"
            >
              Security
            </Link>
          </div>

          {/* Notifications settings: per-category in-app/email + master mute. */}
          <div className="flex w-full items-center gap-4">
            <div>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="32" height="32" rx="8" fill="#F7F7F7" />
                <path
                  d="M16 9.6a3.2 3.2 0 0 0-3.2 3.2v.96c0 1.6-.64 3.13-1.76 4.26l-.24.24v1.34h10.4v-1.34l-.24-.24a6.02 6.02 0 0 1-1.76-4.26v-.96A3.2 3.2 0 0 0 16 9.6zm0 12.8a1.6 1.6 0 0 0 1.6-1.6h-3.2a1.6 1.6 0 0 0 1.6 1.6z"
                  fill="#43526E"
                />
              </svg>
            </div>
            <Link
              to="/settings/notifications"
              className="text-[#0A0F2D] text-base font-medium"
            >
              Notifications
            </Link>
          </div>
        </div>

        <div
          className="w-[75%] flex justify-center items-center py-2 rounded-lg mt-4 border border-[#FF2D5580] text-[#FF3B30] cursor-pointer"
          onClick={handleLogout}
        >
          Logout
        </div>
      </div>
    </div>
  );
};

export default PlayerHeaderSubmenu;
